const INTL: Record<string, string> = { uk: 'uk-UA', en: 'en-GB', pl: 'pl-PL', ro: 'ro-RO', ru: 'ru-RU' };

export function intlLocale(l: string): string {
  return INTL[l] ?? l;
}

export function formatDate(iso: string | null | undefined, l: string, withTime = true): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(intlLocale(l), {
    day: 'numeric',
    month: 'long',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(d);
}

export function formatTime(iso: string, l: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const sameDay = new Date().toDateString() === d.toDateString();
  return new Intl.DateTimeFormat(intlLocale(l), sameDay ? { hour: '2-digit', minute: '2-digit' } : { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(d);
}

/** Time of day only ("14:05"). */
export function formatClock(iso: string, l: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(intlLocale(l), { hour: '2-digit', minute: '2-digit' }).format(d);
}

/** 75 → "1:15" */
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** Hide most of the destination on the code screen: "+380 67 *** ** 67", "na***@mail.com". */
export function maskDestination(d: string): string {
  const v = d.trim();
  if (v.includes('@')) {
    const [user = '', domain = ''] = v.split('@');
    return `${user.slice(0, 2)}${'*'.repeat(Math.max(1, user.length - 2))}@${domain}`;
  }
  const digits = v.replace(/\D/g, '');
  if (digits.length <= 4) return v;
  return `${v.startsWith('+') ? '+' : ''}${digits.slice(0, Math.min(5, digits.length - 4))}…${digits.slice(-2)}`;
}
